import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/native';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { View, Text, TextInput, Modal, Pressable } from 'react-native';
import webStyled from '@emotion/styled';
import * as colors from 'app/src/styles/colors';

import {
  elRed,
  elGray
} from '../../../styles/colors';

export const SellerUsersContainer = styled(View)`
  padding: 40px;
`;

export const ButtonContainer = styled(View)`

`;

export const AddSellerUserButton = styled(Pressable)`
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
  margin-top: 5px;
  width: 80%;
  align-self: center;
  background-color: #fff;
  text-align: center;
`;